export function isObject(maybePlain: any): boolean {
    return !!maybePlain && maybePlain.constructor === Object;
}
